import React, { useMemo } from 'react';
import styled from 'styled-components';
import _find from 'lodash/find';
import { useTranslation } from 'react-i18next';
import { FilterItem } from './types';
import { Icon } from '../icon/Icon';

const StyledLabel = styled.div<{ $newLayout: boolean }>`
	overflow: hidden;
	min-width: 1px;
	font-size: 14px;
	display: flex;
	gap: 6px;
	align-items: center;
	flex-direction: ${({ $newLayout }) => $newLayout ? 'row-reverse' : 'row'};
`;

const StyledDefaultText = styled.span`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	flex: 1 auto;
`;

const StyledSelectionText = styled.span`
	white-space: nowrap;
	flex: 0 auto;
	background: #7696FE;
	color: #fff;
	border-radius: 2px;
	font-size: 12px;
	font-weight: 500;
	min-width: 20px;
	text-align: center;
	display: inline-block;
	height: 18px;
`;

const StyledFilterIcon = styled(Icon)`
	color: #1A2F52;
	font-size: 14px;
`;

type SelectionStatusProps = {
		active: boolean;
		label: string;
		compactLabel?: boolean;
		selection: string[];
		items: FilterItem[];
		hideExtraLabel?: boolean;
		newLayout?: boolean;
}

export function FilterStatus({
	active,
	selection = [],
	items,
	label,
	compactLabel = false,
	newLayout = false,
}: SelectionStatusProps) {
	const { t } = useTranslation();

	const firstSelected = useMemo(() => {
		return active ? _find(items, (item) => item.id === selection?.[0]) : null;
	}, [active, items, selection]);

	const selectionCount = selection.length - 1;

	const selectionLabel = compactLabel ? t('+ {{count}}', {
		count: selectionCount
	}) : t('+ {{count}} more', {
		count: selectionCount
	});

	const selectionCountNewLayout = selection.length;

	const selectionLabelNewLayout = t('{{count}}', {
		count: selectionCountNewLayout
	});

	return <StyledLabel $newLayout={newLayout}>
		{active && !newLayout ? <>
			<StyledDefaultText>{firstSelected?.label}</StyledDefaultText>
			{selection && selection.length > 1 ? <StyledSelectionText>{selectionLabel}</StyledSelectionText> : null}
		</> : <StyledDefaultText>{label}</StyledDefaultText>}
		{newLayout && active && selection.length > 0 ? 
			<StyledSelectionText>{selectionLabelNewLayout}</StyledSelectionText> : 
			<StyledFilterIcon name="filter" />
		}
	</StyledLabel>;
}
